import LoadingFallback from "./LoadingFallback";
export default LoadingFallback;
